
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import BaseUpload from './BaseUpload.vue'
// @ts-ignore
import CircleProgress from 'vue-circleprogressbar'
import FileItem from './FileItem.vue'
import { creatMaterialFileSymlink } from '@/api/placeOrder'
import { handleUrl } from '../../helper'
import { Action } from 'vuex-class'
import { IServiceMap } from '@/business/BusinessFormData'
import { IFileList, IOrderForm } from '@/types/placeOrderTypes'
import { FileTypes, sizeFilter, UploadService } from './fileOperations'

@Component({
  components: {
    BaseUpload,
    CircleProgress,
    FileItem,
  },
})
export default class PdfUpload extends Vue {
  @Action('setOrderId') setOrderId: any

  @Prop({ default: false }) uploading!: boolean
  @Prop({ default: false }) checking!: boolean
  @Prop({ default: () => [] }) pdfList!: any[]
  @Prop({ required: true }) order_id!: string
  @Prop({}) formInfo!: IServiceMap
  @Prop() form!: IOrderForm
  @Prop() files!: IFileList[]
  @Prop() checkForm!: Function
  @Prop() screenForm!: Function
  @Prop() selectFileType!: number

  get title() {
    return (this.selectFileType === 0 ? '对照' : '') + 'PDF文件'
  }

  get showMoreButton() {
    return (
      (this.selectFileType === 0 && this.formInfo.formData.material?.type !== 3) ||
      (this.selectFileType === 3 && this.pdfList.length === 1)
    )
  }

  get QuestionBank() {
    return this.selectFileType == 3
  }

  get PDF2FBD() {
    return this.formInfo.formData.service_content == 24
  }

  get isMutiple() {
    return !this.PDF2FBD
  }

  @Emit('update:pdfList')
  updatePdfList(list: any[]) {
    return list
  }

  @Emit('upload-start')
  setUploading(value: boolean) {
    return value
  }

  sizeFilter(size: number) {
    return sizeFilter(size)
  }

  async handleFileSelected(files: any[]) {
    if (files.length) {
      this.updatePdfList([...this.pdfList, ...files])
    }
  }

  selectMore() {
    ;(this.$refs.baseUpload as any).selectFile()
  }

  togglePdfType() {
    this.$emit('toggle-pdf-type')
  }

  async startUpload() {
    await UploadService.uploadFiles({
      context: this,
      fileList: this.pdfList,
      fileType: FileTypes.PDF,
      checkForm: this.checkForm,
      screenForm: this.screenForm,
      filterCondition: (item, form) =>
        item.pdf && !form.material.oss_pdf_files.filter((pdf: any) => pdf!.name === item.pdf!.name).length,
      handleExistingFile: async (item, path, form) => {
        if (!form.material.oss_pdf_files) form.material.oss_pdf_files = []

        const symlinkData = await creatMaterialFileSymlink({
          ticket_id: this.order_id,
          origin_path: path,
          name: item.pdf!.name,
          path_alias: form.material.type === 3 ? 'content_pdf' : 'content_compare_pdf',
        })

        form.material.oss_pdf_files.push({
          path: handleUrl(symlinkData.symlink_path),
          is_del: false,
          extension: 'pdf',
          name: item.pdf!.name,
          md5: item.md5,
          type: item.type,
        })
      },
      afterUpload: (item, symlinkData, form) => {
        if (!form.material.oss_pdf_files) form.material.oss_pdf_files = []

        form.material.oss_pdf_files.push({
          path: handleUrl(symlinkData.symlink_path),
          is_del: false,
          extension: 'pdf',
          name: item.pdf!.name,
          md5: item.md5,
          type: item.type,
        })
      },
    })
  }

  removePdfFile(name: string) {
    const pdfIndex = this.files.findIndex(item => item.pdf && item.pdf.name === name)
    const ListIndex = this.pdfList.findIndex(item => item.pdf && item.pdf.name === name)
    this.files.splice(pdfIndex, 1)
    this.pdfList.splice(ListIndex, 1)
    if (
      this.form &&
      this.form.material.oss_pdf_files &&
      this.form.material.oss_pdf_files.filter(item => item.name === name).length
    ) {
      this.form.material.oss_pdf_files.splice(ListIndex, 1)
    }
  }

  downloadPdf(name: string) {
    if (this.form && this.form.material && this.form.material.oss_pdf_files) {
      const pdf = this.form.material.oss_pdf_files.find(item => item.name === name)
      const a = document.createElement('a')
      let path = ''
      if (pdf!.path?.includes('+')) {
        path = pdf!.path!.replaceAll('+', '%2B')
      } else {
        path = pdf!.path!
      }
      a.href = `https://hexin-worksheet.oss-cn-shanghai.aliyuncs.com/${path}`
      a.click()
    }
  }
}
